export const ADMIN = 'ADMIN';
export const RETAILER = 'RETAILER';
